<template>
    <b-overlay :show="loading" :opacity="0.4">
        <form class="personal-info-form" @submit.prevent="processUpdateInfo" method="post">
            <h4 class="personal-info-form__title" v-if="!inBooking" v-html="TEXTS.render(`PERSONAL_INFO_HEADER`)"></h4>
            <h4 class="personal-info-form__title" v-if="inBooking" v-html="TEXTS.render(`PERSONAL_INFO_BOOKING_HEADER`)"></h4>
            <p class="personal-info-form__desc" v-if="!inBooking">{{ TEXTS.render(`PERSONAL_INFO_SUBHEADER`) }}</p>
            <p class="personal-info-form__desc" v-if="inBooking" v-html="personalInfoSubheader"></p>
            <p>{{error}}</p>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1">{{ TEXTS.render(`PERSONAL_INFO_FIRSTNAME_HEADER`) }} <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="details.firstName" :disabled="loadingDetails"  @keydown="validateLettersOnly">
                        <div class="mt-1 text-danger font-weight-bold" v-html="validations.firstName" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1">{{ TEXTS.render(`PERSONAL_INFO_LASTNAME_HEADER`) }} <span v-if="personalInfoType !== 'cso' || !inBooking" class=text-danger>*</span></label>
                        <input type="text" class="form-control" v-model="details.lastName" :disabled="loadingDetails"  @keydown="validateLettersOnly">
                        <div class="mt-1 text-danger font-weight-bold" v-html="validations.lastName" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1">{{ TEXTS.render(`PERSONAL_INFO_PHONE_HEADER`) }} <span class="text-danger">*</span></label>
                        <input type="number" :placeholder="TEXTS.render(`PERSONAL_INFO_PHONE_PLACEHOLDER`)" class="form-control" v-model="details.phone" :disabled="loadingDetails" >
                        <div>
                            <small>{{ TEXTS.render(`PERSONAL_INFO_PHONE_NOTE`) }}</small>
                        </div>
                        <div class="mt-1 text-danger font-weight-bold" v-html="validations.phone" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1">{{ TEXTS.render(`PERSONAL_INFO_EMAIL_HEADER`) }} <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="details.email" :disabled="loadingDetails" :readonly=isReadonly>
                        <div class="mt-1 text-danger font-weight-bold" v-html="validations.email" />
                    </div>
                </div>
            </div>

            <div class="row mt-3" v-show="displayEndTerms">
                <div class="col-12">
                    <div class="font-weight-bold" v-html="(this.bookingState.endTermsHeader || TEXTS.render(`BOOKING_FORM_END_TERMS_HEADER`))"></div>
                    <div class="form-check pl-0 pb-2" v-show="this.bookingState.endTermsContent && this.bookingState.endTermsContent !== ''">
                        <input type="checkbox" id="acknowledge-checkbox" class="form-check-input" v-model="acceptedTerms">
                        <label for="acknowledge-checkbox" class="form-check-label paragraph-reduced" v-html="this.bookingState.endTermsContent"></label>
                    </div>
                    <div class="form-check pl-0 pb-2" v-show="this.bookingState.endTermsContent2 && this.bookingState.endTermsContent2 !== ''">
                        <input type="checkbox" id="acknowledge-checkbox-2" class="form-check-input" v-model="acceptedTerms2">
                        <label for="acknowledge-checkbox-2" class="form-check-label paragraph-reduced" v-html="this.bookingState.endTermsContent2"></label>
                    </div>
                    <div class="form-check pl-0 pb-2" v-show="this.bookingState.endTermsContent3 && this.bookingState.endTermsContent3 !== ''">
                        <input type="checkbox" id="acknowledge-checkbox-3" class="form-check-input" v-model="acceptedTerms3">
                        <label for="acknowledge-checkbox-3" class="form-check-label paragraph-reduced" v-html="this.bookingState.endTermsContent3"></label>
                    </div>
                    <div class="mt-1 text-danger font-weight-bold" v-html="validations.endTerms" />
                </div>
            </div>
            <div class="row" v-if="!inBooking">
                <div class="col-md-3">
                    <ColoredButton type="submit" id="profileUpdateBtn">{{ TEXTS.render(`PERSONAL_INFO_BTN_UPDATE`) }}</ColoredButton>
                </div>
            </div>
            <div class="toast profile-toast">
                <div class="toast-body profile-toast__body">
                    <i class="icon icon-check"></i> {{ TEXTS.render(`PERSONAL_INFO_UPDATE_SUCCESS`) }}
                </div>
            </div>
        </form>
    </b-overlay>
</template>

<script>
    import BookingStateManager from '../../../../common/utils/BookingStateManager';
    import ColoredButton from '../../../../common/components/ColoredButton'
    import CheckboxWithLabel from '../../../../common/components/CheckboxWithLabel'
    import helper from '../../../../helper';
    import Texts from '../../../../common/utils/Texts'
    import BookingAcceptedTermsMixin from '../../../../common/mixins/BookingAcceptedTermsMixin';
    import GeneralBookingSettingMixin from '../../../../common/mixins/GeneralBookingSettingMixin';

    /**
    * Task:     BAUM-395
    * Author:   Joseph Ricohermoso
    * Date:     2021-05-26
    * Desc:     We only need generalBookingSetting() so let's clear other unused implementations
    */
    // It's okay to override the mixin before we use it.
    // Especially if not all mixins features is expected to be used by the component implementing the mixin.
    const GeneralBookingSettingMixinCopy = { ...GeneralBookingSettingMixin };
    GeneralBookingSettingMixinCopy.mounted = function() {};
    GeneralBookingSettingMixinCopy.computed = {
        generalBookingSetting: GeneralBookingSettingMixin.computed.generalBookingSetting
    }

    export default {
        mixins: [
            BookingAcceptedTermsMixin,
            GeneralBookingSettingMixinCopy
        ],
        components: {
            ColoredButton,
            CheckboxWithLabel
        },
        props: {
            inBooking: '',
            transactionState: {
                type: Object
            },
            hideNames : Boolean
        },
        data() {
            return {
                loadingDetails: true,
                details: {
                    firstName: '',
                    lastName: '',
                    phone: '',
                    email: ''
                },
                agentEmail: null,
                validations: {
                    firstName: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    endTerms: '',
                    endTerms2: '',
                    endTerms3: '',
                    valid: true
                },
                validatePhone: (event) => helper.phoneNumberValidation(event),
                validateLettersOnly: (event) => helper.lettersOnlyValidation(event),
                isReadonly: true,
                acceptedTerms: false,
                acceptedTerms2: false,
                acceptedTerms3: false,
                bookingStateManager: null,
                state: null
            }
        },
        methods: {
            resetValidation() {
                if(!this.bookingState.endTermsContent || this.bookingState.endTermsContent === '') {
                    this.acceptedTerms = true;
                }

                if(!this.bookingState.endTermsContent2 || this.bookingState.endTermsContent2 === '') {
                    this.acceptedTerms2 = true;
                }
        
                if(!this.bookingState.endTermsContent3 || this.bookingState.endTermsContent3 === '') {
                    this.acceptedTerms3 = true;
                }
                for (const key in this.validations) {
                    if (this.validations.hasOwnProperty(key)) {
                        if (typeof key === 'string') {
                            this.validations[key] = '';
                            continue;
                        }
                    }
                }
                this.validations.valid = true;
            },
            validate(event, disableDispatch) {
                this.resetValidation();
                var checkCurrentPage = this.$route.fullPath; 
                
                if (!(/^[^-\s][a-zA-Z0-9_\s-]+$/i.test(this.details.firstName) && this.details.firstName.length <= 50)) {
                    this.validations.valid = false;
                    this.validations.firstName = Texts.render(`PERSONAL_INFO_VALIDATION_FIRSTNAME`);
                }
                if (this.personalInfoType != "cso" && !(/^[^-\s][a-zA-Z0-9_\s-]+$/i.test(this.details.lastName) && this.details.lastName.length <= 50)) {
                    this.validations.valid = false;
                    this.validations.lastName = Texts.render(`PERSONAL_INFO_VALIDATION_LASTNAME`);
                }

                if (this.personalInfoType === "cso" && checkCurrentPage.indexOf("/booking/form") > -1 && this.details.lastName) {
                    if (!(/^[^-\s][a-zA-Z0-9_\s-]+$/i.test(this.details.lastName) && this.details.lastName.length <= 50)) {
                        this.validations.valid = false;           
                        this.validations.lastName = Texts.render(`PERSONAL_INFO_VALIDATION_LASTNAME`);
                    }  
                }

                if (this.personalInfoType === "cso" && checkCurrentPage.indexOf("/booking/my-profile") > -1 && !(/^[^-\s][a-zA-Z0-9_\s-]+$/i.test(this.details.lastName) && this.details.lastName.length <= 50)) {
                    this.validations.valid = false;
                    this.validations.lastName = Texts.render(`PERSONAL_INFO_VALIDATION_LASTNAME`);
                }

                if (!(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,4}$/im.test(this.details.phone))) {
                    this.validations.valid = false;
                    this.validations.phone = Texts.render(`PERSONAL_INFO_VALIDATION_PHONE`);
                }
                if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.details.email)) || !(/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,10})+$/.test(this.details.email))) {
                    this.validations.valid = false;
                    this.validations.email = Texts.render(`PERSONAL_INFO_VALIDATION_EMAIL`);
                }
                if (this.details.email.trim() !== this.$store.getters.GET_PERSONAL_INFO.email.trim()) {
                    if (!this.inBooking || (this.inBooking && this.personalInfoType === 'resident')) {
                        this.validations.valid = false;
                        this.validations.email = Texts.render(`PERSONAL_INFO_VALIDATION_EMAIL_NO_CHANGE`);
                    }
                }
                if (
                    this.bookingState.hasEndTerms === 'yes'
                    && this.bookingState.isAgreedToTerms ==='yes'
                    && (
                        (this.bookingState.endTermsContent &&
                            this.bookingState.endTermsContent !== '' &&
                            !this.bookingState.acceptedTerms) ||
                        (this.bookingState.endTermsContent2 &&
                            this.bookingState.endTermsContent2 !== '' &&
                            !this.bookingState.acceptedTerms2) ||
                        (this.bookingState.endTermsContent3 &&
                            this.bookingState.endTermsContent3 !== '' &&
                            !this.bookingState.acceptedTerms3)
                    )
                ) {
                    this.validations.endTerms = 'Please accept the terms and conditions';
                }

                if (this.inBooking) {
                    this.$emit('onChange', { validations: this.validations, details: this.details } );
                }

                return this.validations.valid
            },
            processUpdateInfo(event) {
                this.validate();

                if (this.validations.valid) {
                    this.$store.dispatch('updateProfile', {
                        email: this.details.email,
                        firstname: this.details.firstName,
                        lastname: this.details.lastName,
                        phone: this.details.phone,
                    });
                }
            },
            getPersonalInfo() {
                const info = this.$store.getters['GET_PERSONAL_INFO'];

                // BAUM-739: We now set the value based on returned value of the function.
                // In the old code, we detect the presence of storage receiver info in here.
                let receiverInfo = this.applyReceiverInfo();

                /*
                    Stry: [HYP-02] CSO name defaulting - remove defaulting of first name & last name
                    Date: 2021-03-10
                    Auth: Franco Mapua
                    Desc: remove default for first name & last name
                */
                if(!this.hideNames || this.$store.getters.GET_PERSONAL_INFO.type === 'resident'){
                    this.details.firstName = (receiverInfo && receiverInfo.firstName) || info.firstName,
                    this.details.lastName = (receiverInfo && receiverInfo.lastName) || info.lastName
                }

                if (this.hideNames && this.$store.getters.GET_PERSONAL_INFO.type === 'cso' && receiverInfo) {
                    this.details.firstName = receiverInfo.firstName;
                    this.details.lastName = receiverInfo.lastName;
                }
                
                this.details.phone = (receiverInfo && receiverInfo.phone) || info.phone,
                this.details.email = (receiverInfo && receiverInfo.email) || info.email;
                this.loadingDetails = false;
            },
            initBookingStateManager() {
                if (this.inBooking) {
                    this.bookingStateManager = new BookingStateManager();
                    this.state = this.bookingStateManager.loadBookingStateFromUrl(window.location.href);
                }
            },
            /**
             * Task:    BAUM-739
             * Author:  Joseph Ricohermoso
             * Date:    2021-07-12
             * Details: Created this separate functions for reusability purposes.
             */
            applyReceiverInfo() {
                // If receiver info is available now, use it instead of a null value
                let receiverInfo = null;
                if (this.inBooking && this.state.receiverInfo) {
                    receiverInfo = {
                        ...this.state.receiverInfo
                    }
                }
                return receiverInfo;
            },
            prefillFieldsWithUnwantedCSO() {
                let receiverInfo = this.applyReceiverInfo();

                this.details.firstName = (receiverInfo && receiverInfo.firstName) || this.details.firstName,
                this.details.lastName = (receiverInfo && receiverInfo.lastName) || this.details.lastName,
                this.details.phone = (receiverInfo && receiverInfo.phone) || this.details.phone,
                this.details.email = (receiverInfo && receiverInfo.email) || this.details.email;
            }
            // End BAUM-739
        },
        mounted() {
            // Task: BAUM-739 Moved this function on this location to immediately finish it's task upon mounted.
            this.initBookingStateManager();

            if(this.$store.getters.GET_PERSONAL_INFO.type === 'cso') {
                if (!this.inBooking) {
                    setTimeout(() => {
                        this.getPersonalInfo();
                    }, 1000);
                } else {
                    this.isReadonly= false;
                    const localProfile = JSON.parse(localStorage.BasicDetails);
                    this.agentEmail = localProfile.email || null;

                    const general_setting = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING;
                    const use_cso_details = general_setting && !!general_setting.use_cso_details;

                    /**
                    * Task:     BAUM-395
                    * Author:   Joseph Ricohermoso
                    * Date:     2021-05-26
                    * Desc:     If CSO account, and if auto accept end terms is ON. Let's pre-select the end terms checkbox
                    */
                    if (this.displayEndTerms && this.generalBookingSetting.is_autoselect_for_cso) {
                        this.acceptedTerms  = true;
                        this.acceptedTerms2 = true;
                        this.acceptedTerms3 = true;
                    }

                    if (use_cso_details) {
                        setTimeout(() => {
                            this.getPersonalInfo();
                        }, 1000);
                    } else {
                        // Task: BAUM-739 We still need to prefill from storage even if we set the form to empty fillable
                        this.prefillFieldsWithUnwantedCSO();
                        this.loadingDetails = false;
                    }
                }
            } else {
                setTimeout(() => {
                    this.getPersonalInfo();
                }, 1000);
            }
        },
        computed: {
            TEXTS : ()=>Texts,
            loading() {
                return this.$store.getters['GET_PERSONAL_INFO'].loading;
            },
            error() {
                return this.$store.getters['GET_PERSONAL_INFO'].error;
            },
            personalInfoType(){
                return this.$store.getters.GET_PERSONAL_INFO.type
            },
            selectedServiceWording(){
                if(this.bookingState && this.bookingState.selectedService){
                    return this.bookingState.selectedService.wording
                }
            },
            personalInfoSubheader(){
                if(this.selectedServiceWording && this.selectedServiceWording.personal_info_subheading){
                    return this.selectedServiceWording.personal_info_subheading
                }
                else{
                    return Texts.render(`PERSONAL_INFO_BOOKING_SUBHEADER`)
                }
            }
        },
        watch: {  
            'details': {
                handler(n, o) {
                    if (this.inBooking) {
                        this.$store.dispatch("setBookingState", { personalInfo: { ...this.$store.getters.GET_BOOKING_STATE.personalInfo, ...{...n} }, receivingAgent: this.agentEmail });

                        /**
                        * Task:         BAUM-751
                        * Author:       Joseph Ricohermoso
                        * Date:         2021-07-13
                        * Description:  When in booking, if email has changed for resident (probably readonly prop for email field is removed) don't persist it.
                        *               Residents are now allowed to change the email address field in booking form. Persist current resident email instead.
                        */
                        const modifiedN = {}; // Use this object to modified the persisted fields
                        if (this.personalInfoType === 'resident' && n.email.trim() !== this.$store.getters.GET_PERSONAL_INFO.email.trim()) {
                            modifiedN['email'] = this.$store.getters.GET_PERSONAL_INFO.email.trim();
                        }

                        /**
                        * Task:         BAUM-724
                        * Author:       Joseph Ricohermoso
                        * Date:         2021-07-08
                        * Description:  Save in storage every detail's changes in booking page
                        */
                        this.state.receiverInfo = {...n, ...modifiedN};
                        this.bookingStateManager.saveBookingState(this.state);
                    }
                },
                deep: true
            }  
        },
    }
</script>